import { render } from "./ios-git-network.vue?vue&type=template&id=6574d1ee"
import script from "./ios-git-network.vue?vue&type=script&lang=js"
export * from "./ios-git-network.vue?vue&type=script&lang=js"
script.render = render

export default script